import { render } from "./StoryblokClick.vue?vue&type=template&id=7ef4bea7&scoped=true"
import script from "./StoryblokClick.vue?vue&type=script&lang=js"
export * from "./StoryblokClick.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef4bea7"]])

export default __exports__